import React from 'react';

import { Box } from '@nerdwallet/currency/components/Box';
import { Button } from '@nerdwallet/currency/components/Button';
import { SecureEncryptionMessage } from '@nerdwallet/currency/components/SecureEncryptionMessage';
import { Stack } from '@nerdwallet/currency/components/Stack';
import { Text } from '@nerdwallet/currency/components/Text';
import { Title } from '@nerdwallet/currency/components/Title';

import InstitutionIcon from '@components/institution-icon/institution-icon';
import { getGenericIconForAccountType } from '@lib/selectors/yodlee';
import DialogContentWithCloseButton from '@components/mui/dialog-content-with-close-button';
import { usePlaidModalVisibility } from './plaid-modal-visibility-context';

const iconURL =
  'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-bank.png';

interface PlaidErrorProps {
  errorTitle?: string;
  errorSubtitle?: string;
  buttonText?: string;
  failureMessage?: string;
  handlePrimaryCtaClick?: () => void;
}

const PlaidError: React.FC<PlaidErrorProps> = ({
  errorTitle = "Let's try linking again later",
  errorSubtitle = "It's not you - there's an issue that might take a while to fix. Give it some time and try again later.",
  buttonText = 'Go back to accounts list',
  failureMessage = 'Linking failed',
  handlePrimaryCtaClick,
}) => {
  const { setShowPlaidVisibility } = usePlaidModalVisibility();

  return (
    <DialogContentWithCloseButton
      onClose={() => setShowPlaidVisibility({ show: false })}
    >
      <Stack spacing={3}>
        <Title size="small">{errorTitle}</Title>
        <Box
          border="1"
          borderColor="neutral-lighter"
          padding={2}
          alignItems="center"
          display="flex"
        >
          <InstitutionIcon
            altText="Generic bank icon"
            isInError
            src={iconURL ?? getGenericIconForAccountType('BANK')}
          />
          <Box paddingX={2}>
            <Text size="small" light>
              {failureMessage}
            </Text>
          </Box>
        </Box>
        <Text>{errorSubtitle}</Text>
        <Box paddingY={3}>
          <Button
            primary
            block
            onClick={() =>
              handlePrimaryCtaClick
                ? handlePrimaryCtaClick()
                : setShowPlaidVisibility({ show: false })
            }
          >
            {buttonText}
          </Button>
        </Box>
        <SecureEncryptionMessage />
      </Stack>
    </DialogContentWithCloseButton>
  );
};

export default PlaidError;
